import styles from "./horizontalScroll.module.css";
import {useEffect, useRef, useState} from "react";

export default function HorizontalScroll({children, style}){
    const scroller = useRef(null);
    // Drag state lives in a ref so mouse moves don't re-render.
    const drag = useRef({active: false, moved: false, startX: 0, startLeft: 0});
    const [canPrev, setCanPrev] = useState(false);
    const [canNext, setCanNext] = useState(false);

    function updateArrows(){
        const el = scroller.current;
        if (!el) return;
        setCanPrev(el.scrollLeft > 1);
        setCanNext(el.scrollLeft + el.clientWidth < el.scrollWidth - 1);
    }

    useEffect(() => {
        const el = scroller.current;
        updateArrows();
        el.addEventListener("scroll", updateArrows, {passive: true});
        window.addEventListener("resize", updateArrows);
        // Images load late and change scrollWidth.
        el.addEventListener("load", updateArrows, true);

        // Mouse drag-to-scroll. Touch + trackpad keep their native scrolling.
        function onMove(e){
            if (!drag.current.active) return;
            const dx = e.clientX - drag.current.startX;
            if (Math.abs(dx) > 5) drag.current.moved = true;
            if (drag.current.moved){
                el.classList.add(styles.dragging);
                el.scrollLeft = drag.current.startLeft - dx;
            }
        }
        function onUp(){
            drag.current.active = false;
            el.classList.remove(styles.dragging);
        }
        window.addEventListener("mousemove", onMove);
        window.addEventListener("mouseup", onUp);
        return () => {
            el.removeEventListener("scroll", updateArrows);
            window.removeEventListener("resize", updateArrows);
            el.removeEventListener("load", updateArrows, true);
            window.removeEventListener("mousemove", onMove);
            window.removeEventListener("mouseup", onUp);
        };
    }, []);

    function onMouseDown(e){
        if (e.button !== 0) return;
        drag.current = {active: true, moved: false, startX: e.clientX, startLeft: scroller.current.scrollLeft};
    }

    // Swallow the click that ends a drag so clickable children (awards) don't fire.
    function onClickCapture(e){
        if (drag.current.moved){
            e.preventDefault();
            e.stopPropagation();
            drag.current.moved = false;
        }
    }

    function scrollByPage(direction){
        const el = scroller.current;
        el.scrollBy({left: direction * el.clientWidth * 0.8, behavior: "smooth"});
    }

    return (
        <div className={styles.wrapper}>
            {canPrev && <button type="button" aria-label="Zurück" className={`${styles.arrow} ${styles.prev}`}
                                onClick={() => scrollByPage(-1)}>‹</button>}
            <div ref={scroller} className={`${styles.carousel} ${style}`}
                 onMouseDown={onMouseDown} onClickCapture={onClickCapture}
                 onDragStart={(e) => e.preventDefault()}>
                <div className={`horizontal ${styles.inner_carousel}`}>
                    {children}
                </div>
            </div>
            {canNext && <button type="button" aria-label="Weiter" className={`${styles.arrow} ${styles.next}`}
                                onClick={() => scrollByPage(1)}>›</button>}
        </div>
    );
}
